import { lazy } from "react";
import { retry } from "utils/helpers";
import payments from "containers/SmartRender/components/payments";
const DETAIL_BOX = lazy(() =>
  retry(() => import("smart-components/DETAIL_BOX"))
);
const HTML_LINK = lazy(() => retry(() => import("smart-components/HTML_LINK")));
const STATIC_CONTENT_BOX = lazy(() =>
  retry(() => import("smart-components/STATIC_CONTENT_BOX"))
);
const HR = lazy(() => retry(() => import("smart-components/HR")));
const IMAGE = lazy(() => retry(() => import("smart-components/IMAGE")));
const IMAGE_WITH_BASE64 = lazy(() =>
  retry(() => import("smart-components/IMAGE_WITH_BASE64"))
);
const TEXT_FIELD = lazy(() =>
  retry(() => import("smart-components/TEXT_FIELD"))
);
const CAROUSEL = lazy(() => retry(() => import("smart-components/CAROUSEL")));
const SELECTION_HEADER = lazy(() =>
  retry(() => import("smart-components/SELECTION_HEADER"))
);
const TAB_NAVIGATION = lazy(() =>
  retry(() => import("smart-components/TAB_NAVIGATION"))
);
const PLANS_TYPE_CARDS = lazy(() =>
  retry(() => import("smart-components/PLANS_TYPE_CARDS"))
);
const PLANS_FEATURES = lazy(() =>
  retry(() => import("smart-components/PLANS_FEATURES"))
);
const PLAN_SUMMARY_CARD = lazy(() =>
  retry(() => import("smart-components/PLAN_SUMMARY_CARD"))
);
const PAGE_FAQS = lazy(() => retry(() => import("smart-components/PAGE_FAQS")));
const MULTI_TEXT_FIELD = lazy(() =>
  retry(() => import("smart-components/MULTI_TEXT_FIELD"))
);
const CHECKBOX_FIELD = lazy(() =>
  retry(() => import("smart-components/CHECKBOX_FIELD"))
);
const HTML_MESSAGE = lazy(() =>
  retry(() => import("smart-components/HTML_MESSAGE"))
);
const DROPDOWN_FIELD = lazy(() =>
  retry(() => import("smart-components/DROPDOWN_FIELD"))
);
const STEPPER = lazy(() => retry(() => import("smart-components/STEPPER")));
const SUGGESTED_ADDONS_CHECKBOX = lazy(() =>
  retry(() => import("smart-components/SUGGESTED_ADDONS_CHECKBOX"))
);
const PAGE_HEADER = lazy(() =>
  retry(() => import("smart-components/PAGE_HEADER"))
);
const NOT_ELIGIBLE = lazy(() =>
  retry(() => import("smart-components/NOT_ELIGIBLE"))
);
const PROMO_CODE_BOX = lazy(() =>
  retry(() => import("smart-components/PROMO_CODE_BOX"))
);
const SINGLE_TEXT_FIELD_UPDATE = lazy(() =>
  retry(() => import("smart-components/SINGLE_TEXT_FIELD_UPDATE"))
);
const PAY_MONTHLY_CARD = lazy(() =>
  retry(() => import("smart-components/PAY_MONTHLY_CARD"))
);
const PAY_TODAY_CARD = lazy(() =>
  retry(() => import("smart-components/PAY_TODAY_CARD"))
);
const PLAN_SELECTION = lazy(() =>
  retry(() => import("smart-components/PLAN_SELECTION"))
);
const PAY_DEVICE_CARD = lazy(() =>
  retry(() => import("smart-components/PAY_DEVICE_CARD"))
);
const PAY_MONTHLY_DETAILS_CARD = lazy(() =>
  retry(() => import("smart-components/PAY_MONTHLY_DETAILS_CARD"))
);
const PAY_MONTHLY_SUMMARY_CARD = lazy(() =>
  retry(() => import("smart-components/PAY_MONTHLY_SUMMARY_CARD"))
);
const PAY_TODAY_SUMMARY_CARD = lazy(() =>
  retry(() => import("smart-components/PAY_TODAY_SUMMARY_CARD"))
);
const ORDER_SUMMARY_CARD = lazy(() =>
  retry(() => import("smart-components/ORDER_SUMMARY_CARD"))
);
const PLAN_DETAILS_CARD = lazy(() =>
  retry(() => import("smart-components/PLAN_DETAILS_CARD"))
);
const ORDER_DETAILS_CARD = lazy(() =>
  retry(() => import("smart-components/ORDER_DETAILS_CARD"))
);
const ORDER_STEPS_CARD = lazy(() =>
  retry(() => import("smart-components/ORDER_STEPS_CARD"))
);
const ORDER_ACTIONS_CARD = lazy(() =>
  retry(() => import("smart-components/ORDER_ACTIONS_CARD"))
);
const DELIVERY_DETAILS_CARD = lazy(() =>
  retry(() => import("smart-components/DELIVERY_DETAILS_CARD"))
);
const BILLING_DETAILS_CARD = lazy(() =>
  retry(() => import("smart-components/BILLING_DETAILS_CARD"))
);
const NEXT_STEPS_CARD = lazy(() =>
  retry(() => import("smart-components/NEXT_STEPS_CARD"))
);
const ESIGN_CARD = lazy(() =>
  retry(() => import("smart-components/ESIGN_CARD"))
);
const SPECIAL_ADDON = lazy(() =>
  retry(() => import("smart-components/SPECIAL_ADDON"))
);
const ADDONS_CHECKBOX = lazy(() =>
  retry(() => import("smart-components/ADDONS_CHECKBOX"))
);
const PORT_IN_AGREE_TO_TNC_CHECKBOX = lazy(() =>
  retry(() => import("smart-components/PORT_IN_AGREE_TO_TNC_CHECKBOX"))
);
const ADDONS_DROPDOWN = lazy(() =>
  retry(() => import("smart-components/ADDONS_DROPDOWN"))
);
const STATE_OF_ISSUE = lazy(() =>
  retry(() => import("smart-components/STATE_OF_ISSUE"))
);
const COUNTRY_OF_ISSUE = lazy(() =>
  retry(() => import("smart-components/COUNTRY_OF_ISSUE"))
);
const PAGE_NAVIGATION = lazy(() =>
  retry(() => import("smart-components/PAGE_NAVIGATION"))
);
const QUICK_ORDER_VIEW = lazy(() =>
  retry(() => import("smart-components/QUICK_ORDER_VIEW"))
);
const VIDEO_PLAYER = lazy(() =>
  retry(() => import("smart-components/VIDEO_PLAYER"))
);
const MODAL_BUTTONS = lazy(() =>
  retry(() => import("smart-components/MODAL_BUTTONS"))
);
const PLAN_BANNER = lazy(() =>
  retry(() => import("smart-components/PLAN_BANNER"))
);
const PLAN_FAQ = lazy(() => retry(() => import("smart-components/PLAN_FAQ")));
const FAQ_LIST = lazy(() => retry(() => import("smart-components/FAQ_LIST")));
const SWITCH_TOGGLE = lazy(() =>
  retry(() => import("smart-components/SWITCH_TOGGLE"))
);
const FIELD_TOGGLE = lazy(() =>
  retry(() => import("smart-components/FIELD_TOGGLE"))
);
const NEW_NUMBER_DISPLAY = lazy(() =>
  retry(() => import("smart-components/NEW_NUMBER_DISPLAY"))
);
const NUMBER_SEARCH = lazy(() =>
  retry(() => import("smart-components/NUMBER_SEARCH"))
);
const HIDE_NUMBER_SELECTION = lazy(() =>
  retry(() => import("smart-components/HIDE_NUMBER_SELECTION"))
);
const GENERAL_NUMBER_SELECTION = lazy(() =>
  retry(() => import("smart-components/GENERAL_NUMBER_SELECTION"))
);
const SILVER_NUMBER_SELECTION = lazy(() =>
  retry(() => import("smart-components/SILVER_NUMBER_SELECTION"))
);
const GOLDEN_NUMBER_SELECTION = lazy(() =>
  retry(() => import("smart-components/GOLDEN_NUMBER_SELECTION"))
);
const ICC_ID_NRIC = lazy(() =>
  retry(() => import("smart-components/ICC_ID_NRIC"))
);
const ICC_ID = lazy(() => retry(() => import("smart-components/ICC_ID")));
const POSTAL_CODE = lazy(() =>
  retry(() => import("smart-components/POSTAL_CODE"))
);
const SELF_PICKUP_POSTAL_CODE = lazy(() =>
  retry(() => import("smart-components/SELF_PICKUP_POSTAL_CODE"))
);
const DOI = lazy(() => retry(() => import("smart-components/DOI")));
const DOB = lazy(() => retry(() => import("smart-components/DOB")));
const CONTACT_NUMBER = lazy(() =>
  retry(() => import("smart-components/CONTACT_NUMBER"))
);
const ALTERNATE_NUMBER = lazy(() =>
  retry(() => import("smart-components/ALTERNATE_NUMBER"))
);
const POST_PAID_NUMBER = lazy(() =>
  retry(() => import("smart-components/POST_PAID_NUMBER"))
);
const PORT_IN_NUMBER = lazy(() =>
  retry(() => import("smart-components/PORT_IN_NUMBER"))
);
const POST_PAID_TELCO_ACCOUNT_NUMBER = lazy(() =>
  retry(() => import("smart-components/POST_PAID_TELCO_ACCOUNT_NUMBER"))
);
const DOC_TYPE = lazy(() => retry(() => import("smart-components/DOC_TYPE")));
const UPLOAD_ID_LATER = lazy(() =>
  retry(() => import("smart-components/UPLOAD_ID_LATER"))
);
const BILLING_ADDRESS_SAME_AS_DELIVERY_ADDRESS = lazy(() =>
  retry(() =>
    import("smart-components/BILLING_ADDRESS_SAME_AS_DELIVERY_ADDRESS")
  )
);
const PRIMARY_ID_UPLOADER = lazy(() =>
  retry(() => import("smart-components/PRIMARY_ID_UPLOADER"))
);
const ID_UPLOADER = lazy(() =>
  retry(() => import("smart-components/ID_UPLOADER"))
);
const CIS_PARTNERS_FORM = lazy(() =>
  retry(() => import("smart-components/CIS_PARTNERS_FORM"))
);
const DELIVERY_ADDRESS_FORM_1 = lazy(() =>
  retry(() => import("smart-components/DELIVERY_ADDRESS_FORM_1"))
);
const DELIVERY_ADDRESS_FORM_2 = lazy(() =>
  retry(() => import("smart-components/DELIVERY_ADDRESS_FORM_2"))
);
const DELIVERY_ADDRESS_FORM_3 = lazy(() =>
  retry(() => import("smart-components/DELIVERY_ADDRESS_FORM_3"))
);
const DELIVERY_ADDRESS_FORM_4 = lazy(() =>
  retry(() => import("smart-components/DELIVERY_ADDRESS_FORM_4"))
);
const DELIVERY_ADDRESS_FORM_5 = lazy(() =>
  retry(() => import("smart-components/DELIVERY_ADDRESS_FORM_5"))
);
const DELIVERY_ADDRESS_FORM_6 = lazy(() =>
  retry(() => import("smart-components/DELIVERY_ADDRESS_FORM_6"))
);
const ADDRESS_LOOKUP = lazy(() =>
  retry(() => import("smart-components/ADDRESS_LOOKUP"))
);
const BILLING_ADDRESS_FORM = lazy(() =>
  retry(() => import("smart-components/BILLING_ADDRESS_FORM"))
);
const BILLING_ADDRESS_FORM_2 = lazy(() =>
  retry(() => import("smart-components/BILLING_ADDRESS_FORM_2"))
);
const BILLING_ADDRESS_FORM_3 = lazy(() =>
  retry(() => import("smart-components/BILLING_ADDRESS_FORM_3"))
);
const BILLING_ADDRESS_FORM_5 = lazy(() =>
  retry(() => import("smart-components/BILLING_ADDRESS_FORM_5"))
);
const BILLING_ADDRESS_FORM_6 = lazy(() =>
  retry(() => import("smart-components/BILLING_ADDRESS_FORM_6"))
);
const NATIONALITY_DROPDOWN = lazy(() =>
  retry(() => import("smart-components/NATIONALITY_DROPDOWN"))
);
const RADIO = lazy(() => retry(() => import("smart-components/RADIO")));
const VERTICAL_RADIO = lazy(() =>
  retry(() => import("smart-components/VERTICAL_RADIO"))
);
const NATIONALITY_RADIO = lazy(() =>
  retry(() => import("smart-components/NATIONALITY_RADIO"))
);
const TELCO_LIST_RADIO = lazy(() =>
  retry(() => import("smart-components/TELCO_LIST_RADIO"))
);
const TELCO_LIST_DROPDOWN = lazy(() =>
  retry(() => import("smart-components/TELCO_LIST_DROPDOWN"))
);
const REGISTERED_UNDER_OWN_NRIC = lazy(() =>
  retry(() => import("smart-components/REGISTERED_UNDER_OWN_NRIC"))
);
const DELIVERY_METHOD_PICKER = lazy(() =>
  retry(() => import("smart-components/DELIVERY_METHOD_PICKER"))
);
const PAYMENT_METHOD_PICKER = lazy(() =>
  retry(() => import("smart-components/PAYMENT_METHOD_PICKER"))
);
const PAYMENT_METHOD_PICKER_2 = lazy(() =>
  retry(() => import("smart-components/PAYMENT_METHOD_PICKER_2"))
);
const PAYMENT_METHOD_PICKER_3 = lazy(() =>
  retry(() => import("smart-components/PAYMENT_METHOD_PICKER_3"))
);
const PROFILE_LANGUAGE = lazy(() =>
  retry(() => import("smart-components/PROFILE_LANGUAGE"))
);
const PAYMENT_QR_VIEWER = lazy(() =>
  retry(() => import("smart-components/PAYMENT_QR_VIEWER"))
);
const GOOGLE_PREDICT_FIELD = lazy(() =>
  retry(() => import("smart-components/GOOGLE_PREDICT_FIELD"))
);
const ADDRESS_ERROR_HANDLER = lazy(() =>
  retry(() => import("smart-components/ADDRESS_ERROR_HANDLER"))
);
const DELIVERY_DATE_PICKER = lazy(() =>
  retry(() => import("smart-components/DELIVERY_DATE_PICKER"))
);
const FREE_DELIVERY_SLOT_PICKER = lazy(() =>
  retry(() => import("smart-components/FREE_DELIVERY_SLOT_PICKER"))
);
const SPECIAL_DELIVERY_SLOT_PICKER = lazy(() =>
  retry(() => import("smart-components/SPECIAL_DELIVERY_SLOT_PICKER"))
);
// const STORE_PICKER_1 = lazy(() =>
//   retry(() => import("smart-components/STORE_PICKER_1"))
// );
// const STORE_PICKER_2 = lazy(() =>
//   retry(() => import("smart-components/STORE_PICKER_2"))
// );
const SELF_PICKUP_STATION_PICKER = lazy(() =>
  retry(() => import("smart-components/SELF_PICKUP_STATION_PICKER"))
);
const SELF_PICKUP_STATION_UPDATER = lazy(() =>
  retry(() => import("smart-components/SELF_PICKUP_LOCATION_UPDATER"))
);
const SMART_MODAL = lazy(() =>
  retry(() => import("smart-components/SMART_MODAL"))
);
const POP_STATION_PICKER = lazy(() =>
  retry(() => import("smart-components/POP_STATION_PICKER"))
);
const SELF_ACTIVATION_DELIVERY_MODAL = lazy(() =>
  retry(() => import("smart-components/SELF_ACTIVATION_DELIVERY_MODAL"))
);
const SCHEDULE_NUMBER_CHANGE_MODAL = lazy(() =>
  retry(() => import("smart-components/SCHEDULE_NUMBER_CHANGE_MODAL"))
);
const SUSPENSION_START_DATE = lazy(() =>
  retry(() => import("smart-components/SUSPENSION_START_DATE"))
);
const SUSPENSION_END_DATE = lazy(() =>
  retry(() => import("smart-components/SUSPENSION_END_DATE"))
);
const REQUEST_SUSPENSION_MODAL = lazy(() =>
  retry(() => import("smart-components/REQUEST_SUSPENSION_MODAL"))
);
const TEXTAREA_FIELD = lazy(() =>
  retry(() => import("smart-components/TEXTAREA_FIELD"))
);
const ACYEN_STORE_PICKER = lazy(() =>
  retry(() => import("smart-components/ACYEN_STORE_PICKER"))
);
const PREPAID_POSTPAID_RADIO = lazy(() =>
  retry(() => import("smart-components/PREPAID_POSTPAID_RADIO"))
);
const TERMINATION_REASON = lazy(() =>
  retry(() => import("smart-components/TERMINATION_REASON"))
);
const CANCELLATION_REASON = lazy(() =>
  retry(() => import("smart-components/CANCELLATION_REASON"))
);
const DELIVERY_FAIL_REASON = lazy(() =>
  retry(() => import("smart-components/DELIVERY_FAIL_REASON"))
);
const TERMINATION_DATE = lazy(() =>
  retry(() => import("smart-components/TERMINATION_DATE"))
);
const TERMS_AND_CONDITIONS = lazy(() =>
  retry(() => import("smart-components/TERMS_AND_CONDITIONS"))
);
const SCROLLABLE_SECTION = lazy(() =>
  retry(() => import("smart-components/SCROLLABLE_SECTION"))
);
const ESIGN_FIELD = lazy(() =>
  retry(() => import("smart-components/ESIGN_FIELD"))
);
const REQUEST_TERMINATION_MODAL = lazy(() =>
  retry(() => import("smart-components/REQUEST_TERMINATION_MODAL"))
);
const TERMINATION_STATUS = lazy(() =>
  retry(() => import("smart-components/SUCCESS_FLEX_BOX"))
);
const SUCCESS_FLEX_BOX = lazy(() =>
  retry(() => import("smart-components/PROFILE_LANGUAGE"))
);
const PAYMENT_BOX = lazy(() =>
  retry(() => import("smart-components/PAYMENT_BOX"))
);
const UPDATE_PAYMENT_CARD = lazy(() =>
  retry(() => import("smart-components/UPDATE_PAYMENT_CARD"))
);
const SHOP_ORDER_SUMMARY = lazy(() =>
  retry(() => import("smart-components/SHOP_ORDER_SUMMARY"))
);
const PAY_LATER_FORM = lazy(() =>
  retry(() => import("smart-components/PAY_LATER_FORM"))
);
const LEGACY_ADYEN_FORM = lazy(() =>
  retry(() => import("smart-components/LEGACY_ADYEN_FORM"))
);
const ADYEN_DROPIN = lazy(() =>
  retry(() => import("smart-components/ADYEN_DROPIN"))
);
const SOCIAL_MEDIA_SIGNIN_OPTIONS = lazy(() =>
  retry(() => import("smart-components/SOCIAL_MEDIA_SIGNIN_OPTIONS"))
);
const HR_WITH_TEXT = lazy(() =>
  retry(() => import("smart-components/HR_WITH_TEXT"))
);
const INLINE_PAGE_HEADERS = lazy(() =>
  retry(() => import("smart-components/INLINE_PAGE_HEADERS"))
);
const SUBMIT_BUTTON = lazy(() =>
  retry(() => import("smart-components/SUBMIT_BUTTON"))
);
const OTP_BOXES = lazy(() => retry(() => import("smart-components/OTP_BOXES")));
const NAVIGATE_LINK = lazy(() =>
  retry(() => import("smart-components/NAVIGATE_LINK"))
);
const PARAGRAPH = lazy(() => retry(() => import("smart-components/PARAGRAPH")));
const SIM_COUNT_SELECTOR = lazy(() =>
  retry(() => import("smart-components/SIM_COUNT_SELECTOR"))
);
const ORDER_SUCCESS_VIEW = lazy(() =>
  retry(() => import("smart-components/ORDER_SUCCESS_VIEW"))
);
const PAYMENT_FORM = lazy(() =>
  retry(() => import("smart-components/PAYMENT_FORM"))
);
const PAYMENT_AMAZON_WIDGETS = lazy(() =>
  retry(() => import("smart-components/PAYMENT_AMAZON_WIDGETS"))
);
const PHONE_LIST = lazy(() =>
  retry(() => import("smart-components/PHONE_LIST"))
);
const PHONE_DETAILS = lazy(() =>
  retry(() => import("smart-components/PHONE_DETAILS"))
);
const OUTSTANDING_INVOICE_CARD = lazy(() =>
  retry(() => import("smart-components/OUTSTANDING_INVOICE_CARD"))
);
const OUTSTANDING_PAYMENT_CARD = lazy(() =>
  retry(() => import("smart-components/OUTSTANDING_PAYMENT_CARD"))
);
const SIM_DETAILS_CARD = lazy(() =>
  retry(() => import("smart-components/SIM_DETAILS_CARD"))
);
const CRITICAL_INFO_DETAILS_CARD = lazy(() =>
  retry(() => import("smart-components/CRITICAL_INFO_DETAILS_CARD"))
);
const ESIM_COMPATIBLE_LIST = lazy(() =>
  retry(() => import("smart-components/ESIM_COMPATIBLE_LIST"))
);
const ACCORDIAN = lazy(() => retry(() => import("smart-components/ACCORDIAN")));
const PAYMENT_UPDATE_CARD_ADYEN_DROPIN = lazy(() =>
  retry(() => import("smart-components/PAYMENT_UPDATE_CARD_ADYEN_DROPIN"))
);
const PAYMENT_UPFRONT_STRIPE_CHECKOUT = lazy(() =>
  retry(() => import("smart-components/PAYMENT_UPFRONT_STRIPE_CHECKOUT"))
);
const PAYMENT_UPFRONT_ADYEN_DROPIN = lazy(() =>
  retry(() => import("smart-components/PAYMENT_UPFRONT_ADYEN_DROPIN"))
);
const CLOSE_ICON = lazy(() =>
  retry(() => import("smart-components/CLOSE_ICON"))
);
const RECEIVE_MY_PACKAGE = lazy(() =>
  retry(() => import("smart-components/RECEIVE_MY_PACKAGE"))
);
const AUTHORIZATION_FORM = lazy(() =>
  retry(() => import("smart-components/AUTHORIZATION_FORM"))
);
const DATE_SLOT_SELECTION = lazy(() =>
  retry(() => import("smart-components/DATE_SLOT_SELECTION"))
);
const ORDER_AUTHORIZATION_CARD = lazy(() =>
  retry(() => import("smart-components/ORDER_AUTHORIZATION_CARD"))
);
const PAYMENT_UPDATE_CARD_STRIPE_CHECKOUT = lazy(() =>
  retry(() => import("smart-components/PAYMENT_UPDATE_CARD_STRIPE_CHECKOUT"))
);
const STRIPE_UPDATE_CARD_CHECKOUT = lazy(() =>
  retry(() => import("smart-components/STRIPE_UPDATE_CARD_CHECKOUT"))
);
const PAYMENT_UPFRONT_FORM = lazy(() =>
  retry(() => import("smart-components/PAYMENT_UPFRONT_FORM"))
);
const PAYMENT_UPDATE_FORM = lazy(() =>
  retry(() => import("smart-components/PAYMENT_UPDATE_FORM"))
);
const MY_INFO_BOX = lazy(() =>
  retry(() => import("smart-components/MY_INFO_BOX"))
);
const PAYMENT_CARD_DETAILS = lazy(() =>
  retry(() => import("smart-components/PAYMENT_CARD_DETAILS"))
);
const EXTENDED_PLAN_SELECTION = lazy(() =>
  retry(() => import("smart-components/EXTENDED_PLAN_SELECTION"))
);
const TOGGLE_LIST = lazy(() =>
  retry(() => import("smart-components/TOGGLE_LIST"))
);
const DELIVERY_DATE_AND_SLOT_PICKER = lazy(() =>
  retry(() => import("smart-components/DELIVERY_DATE_AND_SLOT_PICKER"))
);
const MY_ORDER_DETAILS = lazy(() =>
  retry(() => import("smart-components/MY_ORDER_DETAILS"))
);
const PAST_SERVICE_REQUESTS_DETAILS = lazy(() =>
  retry(() => import("smart-components/PAST_SERVICE_REQUESTS_DETAILS"))
);
const DOCUMENT_UPLOADER = lazy(() =>
  retry(() => import("smart-components/DOCUMENT_UPLOADER"))
);
const PROFILE_DETAIL = lazy(() =>
  retry(() => import("smart-components/PROFILE_DETAIL"))
);
const WINBACK_REWARDS = lazy(() =>
  retry(() => import("smart-components/WINBACK_REWARDS"))
);
const WINBACK_REWARD_ITEM = lazy(() =>
  retry(() => import("smart-components/WINBACK_REWARD_ITEM"))
);
const RESEND_OTT = lazy(() =>
  retry(() => import("smart-components/RESEND_OTT"))
);
const COLLAPSE_FAQ = lazy(() =>
  retry(() => import("smart-components/COLLAPSE_FAQ"))
);
const TERMS_POLICY_MODAL = lazy(() =>
  retry(() => import("smart-components/TERMS_POLICY_MODAL"))
);
const SHIPPING_METHOD_PICKER = lazy(() =>
  retry(() => import("smart-components/SHIPPING_METHOD_PICKER"))
);
const TOGGLE_VISIBILITY = lazy(() =>
  retry(() => import("components/ToggleVisibility"))
);
const FIELD_ITEM_TOGGLE = lazy(() =>
  retry(() => import("smart-components/FIELD_ITEM_TOGGLE"))
);
const PATCH_BLOCK = lazy(() =>
  retry(() => import("smart-components/PATCH_BLOCK"))
);
const DYNAMIC_BOX = lazy(() =>
  retry(() => import("smart-components/DYNAMIC_BOX"))
);
const ESIM_MOBILE_COMPATIBLE_LIST = lazy(() =>
  retry(() => import("smart-components/ESIM_MOBILE_COMPATIBLE_LIST"))
);
const SCROLL_TO_BUTTON = lazy(() =>
  retry(() => import("smart-components/SCROLL_TO_BUTTON"))
);
const SELF_PICKUP_STATION_ADDRESS_PICKER = lazy(() =>
  retry(() => import("smart-components/SELF_PICKUP_STATION_ADDRESS_PICKER"))
);
const INSTRUCTION_STEPPER = lazy(() =>
  retry(() => import("smart-components/INSTRUCTION_STEPPER"))
);
const MULTI_PROMO_CODE_BOX = lazy(() =>
  retry(() => import("smart-components/MULTI_PROMO_CODE_BOX"))
);
const PENDING_ORDERS = lazy(() =>
  retry(() => import("smart-components/PENDING_ORDERS"))
);
const PENDING_ORDERS_DETAILS = lazy(() =>
  retry(() => import("smart-components/PENDING_ORDERS_DETAILS"))
);

const ACTION_LINK = lazy(() =>
  retry(() => import("smart-components/ACTION_LINK"))
);

const ACTION_RADIO = lazy(() =>
  retry(() => import("smart-components/ACTION_RADIO"))
);

const SAVED_CARD_DETAILS = lazy(() =>
  retry(() => import("smart-components/SAVED_CARD_DETAILS"))
);

const EASYPAISA_ONETIME = lazy(() =>
  retry(() => import("smart-components/EASYPAISA_ONETIME"))
);

const JAZZCASH_ONETIME = lazy(() =>
  retry(() => import("smart-components/JAZZCASH_ONETIME"))
);

const ERROR_MESSAGE = lazy(() =>
  retry(() => import("smart-components/ERROR_MESSAGE"))
);

const ERROR_MESSAGE_INFO = lazy(() =>
  retry(() => import("smart-components/ERROR_MESSAGE_INFO"))
);

const LOCATION_PICKER = lazy(() =>
  retry(() => import("smart-components/LOCATION_PICKER"))
);

const UNSUBSCRIBE_CARD = lazy(() =>
  retry(() => import("smart-components/UNSUBSCRIBE_CARD"))
);

const featureMapping = {
  TOGGLE_VISIBILITY,
  COLLAPSE_FAQ,
  HTML_LINK,
  DETAIL_BOX,
  STATIC_CONTENT_BOX,
  HR,
  IMAGE,
  IMAGE_WITH_BASE64,
  TEXT_FIELD,
  MULTI_TEXT_FIELD,
  CHECKBOX_FIELD,
  HTML_MESSAGE,
  DROPDOWN_FIELD,
  STEPPER,
  PAGE_HEADER,
  NOT_ELIGIBLE,
  PROMO_CODE_BOX,
  SINGLE_TEXT_FIELD_UPDATE,
  PAY_MONTHLY_CARD,
  PAY_TODAY_CARD,
  PLAN_SELECTION,
  PAY_DEVICE_CARD,
  PAY_MONTHLY_DETAILS_CARD,
  PAY_MONTHLY_SUMMARY_CARD,
  PAY_TODAY_SUMMARY_CARD,
  ORDER_SUMMARY_CARD,
  PLAN_DETAILS_CARD,
  ORDER_DETAILS_CARD,
  ORDER_STEPS_CARD,
  ORDER_ACTIONS_CARD,
  DELIVERY_DETAILS_CARD,
  BILLING_DETAILS_CARD,
  NEXT_STEPS_CARD,
  ESIGN_CARD,
  SPECIAL_ADDON,
  ADDONS_CHECKBOX,
  SUGGESTED_ADDONS_CHECKBOX,
  PORT_IN_AGREE_TO_TNC_CHECKBOX,
  ADDONS_DROPDOWN,
  STATE_OF_ISSUE,
  COUNTRY_OF_ISSUE,
  PAGE_NAVIGATION,
  QUICK_ORDER_VIEW,
  VIDEO_PLAYER,
  MODAL_BUTTONS,
  PLAN_BANNER,
  PLAN_FAQ,
  FAQ_LIST,
  SWITCH_TOGGLE,
  FIELD_TOGGLE,
  NEW_NUMBER_DISPLAY,
  NUMBER_SEARCH,
  HIDE_NUMBER_SELECTION,
  GENERAL_NUMBER_SELECTION,
  SILVER_NUMBER_SELECTION,
  GOLDEN_NUMBER_SELECTION,
  ICC_ID_NRIC,
  ICC_ID,
  POSTAL_CODE,
  SELF_PICKUP_POSTAL_CODE,
  DOI,
  DOB,
  CONTACT_NUMBER,
  ALTERNATE_NUMBER,
  POST_PAID_NUMBER,
  PORT_IN_NUMBER,
  POST_PAID_TELCO_ACCOUNT_NUMBER,
  DOC_TYPE,
  UPLOAD_ID_LATER,
  BILLING_ADDRESS_SAME_AS_DELIVERY_ADDRESS,
  PRIMARY_ID_UPLOADER,
  ID_UPLOADER,
  CIS_PARTNERS_FORM,
  DELIVERY_ADDRESS_FORM_1,
  DELIVERY_ADDRESS_FORM_2,
  DELIVERY_ADDRESS_FORM_3,
  DELIVERY_ADDRESS_FORM_4,
  DELIVERY_ADDRESS_FORM_5,
  DELIVERY_ADDRESS_FORM_6,
  ADDRESS_LOOKUP,
  BILLING_ADDRESS_FORM,
  BILLING_ADDRESS_FORM_2,
  BILLING_ADDRESS_FORM_3,
  BILLING_ADDRESS_FORM_5,
  BILLING_ADDRESS_FORM_6,
  NATIONALITY_DROPDOWN,
  RADIO,
  VERTICAL_RADIO,
  PREPAID_POSTPAID_RADIO,
  NATIONALITY_RADIO,
  TELCO_LIST_RADIO,
  TELCO_LIST_DROPDOWN,
  REGISTERED_UNDER_OWN_NRIC,
  DELIVERY_METHOD_PICKER,
  PAYMENT_METHOD_PICKER,
  PAYMENT_METHOD_PICKER_2,
  PAYMENT_METHOD_PICKER_3,
  PROFILE_LANGUAGE,
  PAYMENT_QR_VIEWER,
  GOOGLE_PREDICT_FIELD,
  ADDRESS_ERROR_HANDLER,
  DELIVERY_DATE_PICKER,
  FREE_DELIVERY_SLOT_PICKER,
  SPECIAL_DELIVERY_SLOT_PICKER,
  // STORE_PICKER_1,
  // STORE_PICKER_2,
  SELF_PICKUP_STATION_PICKER,
  SELF_PICKUP_STATION_UPDATER,
  SMART_MODAL,
  POP_STATION_PICKER,
  SELF_ACTIVATION_DELIVERY_MODAL,
  SCHEDULE_NUMBER_CHANGE_MODAL,
  SUSPENSION_START_DATE,
  SUSPENSION_END_DATE,
  REQUEST_SUSPENSION_MODAL,
  TEXTAREA_FIELD,
  ACYEN_STORE_PICKER,
  TERMINATION_REASON,
  CANCELLATION_REASON,
  DELIVERY_FAIL_REASON,
  TERMINATION_DATE,
  TERMS_AND_CONDITIONS,
  SCROLLABLE_SECTION,
  ESIGN_FIELD,
  REQUEST_TERMINATION_MODAL,
  TERMINATION_STATUS,
  SUCCESS_FLEX_BOX,
  PAYMENT_BOX,
  UPDATE_PAYMENT_CARD,
  SHOP_ORDER_SUMMARY,
  PAY_LATER_FORM,
  LEGACY_ADYEN_FORM,
  ADYEN_DROPIN,
  SOCIAL_MEDIA_SIGNIN_OPTIONS,
  HR_WITH_TEXT,
  INLINE_PAGE_HEADERS,
  SUBMIT_BUTTON,
  OTP_BOXES,
  NAVIGATE_LINK,
  PARAGRAPH,
  SIM_COUNT_SELECTOR,
  ORDER_SUCCESS_VIEW,
  PAYMENT_FORM,
  PAYMENT_AMAZON_WIDGETS,
  PHONE_LIST,
  PHONE_DETAILS,
  OUTSTANDING_INVOICE_CARD,
  OUTSTANDING_PAYMENT_CARD,
  SIM_DETAILS_CARD,
  CRITICAL_INFO_DETAILS_CARD,
  ESIM_COMPATIBLE_LIST,
  ACCORDIAN,
  PAYMENT_UPDATE_CARD_ADYEN_DROPIN,
  PAYMENT_UPFRONT_ADYEN_DROPIN,
  CLOSE_ICON,
  ...payments,
  RECEIVE_MY_PACKAGE,
  AUTHORIZATION_FORM,
  DATE_SLOT_SELECTION,
  ORDER_AUTHORIZATION_CARD,
  PAYMENT_UPDATE_CARD_STRIPE_CHECKOUT,
  STRIPE_UPDATE_CARD_CHECKOUT,
  PAYMENT_UPFRONT_STRIPE_CHECKOUT,
  PAYMENT_UPFRONT_FORM,
  PAYMENT_UPDATE_FORM,
  MY_INFO_BOX,
  PAYMENT_CARD_DETAILS,
  EXTENDED_PLAN_SELECTION,
  TOGGLE_LIST,
  DELIVERY_DATE_AND_SLOT_PICKER,
  PROFILE_DETAIL,
  WINBACK_REWARDS,
  WINBACK_REWARD_ITEM,
  MY_ORDER_DETAILS,
  PAST_SERVICE_REQUESTS_DETAILS,
  DOCUMENT_UPLOADER,
  RESEND_OTT,
  TERMS_POLICY_MODAL,
  CAROUSEL,
  SELECTION_HEADER,
  TAB_NAVIGATION,
  PLANS_TYPE_CARDS,
  PLANS_FEATURES,
  PLAN_SUMMARY_CARD,
  PAGE_FAQS,
  SHIPPING_METHOD_PICKER,
  FIELD_ITEM_TOGGLE,
  PATCH_BLOCK,
  ESIM_MOBILE_COMPATIBLE_LIST,
  DYNAMIC_BOX,
  SELF_PICKUP_STATION_ADDRESS_PICKER,
  SCROLL_TO_BUTTON,
  INSTRUCTION_STEPPER,
  MULTI_PROMO_CODE_BOX,
  PENDING_ORDERS,
  PENDING_ORDERS_DETAILS,
  ACTION_LINK,
  ACTION_RADIO,
  SAVED_CARD_DETAILS,
  EASYPAISA_ONETIME,
  JAZZCASH_ONETIME,
  ERROR_MESSAGE,
  ERROR_MESSAGE_INFO,
  LOCATION_PICKER,
  UNSUBSCRIBE_CARD
};

export default featureMapping;
